import http from "@utils/request";
/**
 * 获取设备数据，剩余金额，剩余流量和价格
 * @returns 
 */
 export const getAlarmList=(start_time,end_time,site_list,page=0,size=10)=>http({
    method: "POST",
    url: "/phemsjava/getAlarmList",
    data: {
        start_time,end_time,site_list,page,size
    },
})